import { MenuProps, Row } from "antd"
import { FC, useEffect, useState } from "react"
import { useMediaQuery } from "react-responsive"
import { NavLink, useLocation } from "react-router-dom"
import { getUserFromSessionStorage } from "../../components/forms/sign-in"
import Navigation from "../../components/ui/menu/Navigation"
import { SvgIcon } from "../icon"

const WebsiteMenu: FC<MenuProps> = ({ mode, onClick }) => {
  const isTablet = useMediaQuery({ query: "(max-width: 1180px)" })
  const user = getUserFromSessionStorage()
  const isGroupAdmin = user?.type === 1
  const deprecatedGroupAdminLinks = ["/groups", "/courseware"]
  const menu = [
    {
      key: "/students",
      label: (
        <NavLink className={isTablet ? "mobile-menu-item" : ""} to={"/students"}>
          <Row wrap={false} align={"middle"}>
            <SvgIcon type={"studentHatIcon"} /> Students
          </Row>
        </NavLink>
      ),
    },
    {
      key: "/groups",
      label: (
        <NavLink className={isTablet ? "mobile-menu-item" : ""} to={"/groups"}>
          <Row wrap={false} align={"middle"}>
            <SvgIcon type={"groupsIcon"} /> Groups
          </Row>
        </NavLink>
      ),
    },
    {
      key: "/courseware",
      label: (
        <NavLink className={isTablet ? "mobile-menu-item" : ""} to={"/courseware"}>
          <Row wrap={false} align={"middle"}>
            <SvgIcon type={"fileIcon"} /> Courseware
          </Row>
        </NavLink>
      ),
    },
    {
      key: "/reports",
      label: (
        <NavLink className={isTablet ? "mobile-menu-item" : ""} to={"/reports"}>
          <Row wrap={false} align={"middle"}>
            <SvgIcon type={"chartIcon"} /> Reports
          </Row>
        </NavLink>
      ),
    },
    {
      key: "/help",
      label: (
        <NavLink className={isTablet ? "mobile-menu-item" : ""} to={"/help"}>
          <Row wrap={false} align={"middle"}>
            <SvgIcon type={"infoIcon"} /> Help
          </Row>
        </NavLink>
      ),
    },
  ]

  const filteredMenu = isGroupAdmin ? menu.filter(item => !deprecatedGroupAdminLinks.includes(item.key)) : menu

  return <Navigation onClick={onClick} mode={mode} items={filteredMenu} />
}

export default WebsiteMenu
